export default "__VITE_ASSET__D9Cn_ZpS__"